import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ROUTES } from '../../../services/server-route';
import { SettlementServiceService } from '../../../services/raintree/Transmission/settlement-service.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatIconModule } from '@angular/material/icon';
import { UploadDocumentDialogComponent } from '../upload-document-dialog/upload-document-dialog.component';
import { log } from 'console';
import { map } from 'rxjs';
import { ViewTraceComponent } from './view-trace/view-trace.component';
@Component({
  selector: 'app-show-bank-statement-dialog',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './show-bank-statement-dialog.component.html',
  styleUrl: './show-bank-statement-dialog.component.scss'
})
export class ShowBankStatementDialogComponent implements OnInit{

  bankDetails: any [] = [];
isSuccessUpload: any;
traceDetails: any;
  constructor(
    private dialogRef: MatDialogRef<ShowBankStatementDialogComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
    private bankService: SettlementServiceService,
    private toastr: ToastrService,
    private dialog: MatDialog

  ){
  }

  ngOnInit(): void {
    this.getBankTransaction(this.data)    
  }

  closeDialog(){
    this.dialogRef.close()
  }


  getBankTransaction(payload: any) {
    this.bankService.getUnsettledRecords(payload).subscribe({
      next: (result: any) => {
        if (!result.error) {
          //console.log(result);
          this.bankDetails = result.data;
          // .map((item: any) => ({
          //   ...item,
          //   ifsc: item.txnBranch?.ifsc,
          //   bankName: item.txnBranch?.bank_name,
          //   branchName: item.txnBranch?.branch_name,
          //   city: item.txnBranch?.city,
          //   pincode: item.txnBranch?.pincode,
          //   traceDetails:  item.traceDetails
          // }))        
        }
      },
      error: (error: any) => {
        this.toastr.error(error);
      }
    })
  }

  saveExcelFile(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
  }


  exportData() {
    console.log('EXPORT DATA', this.bankDetails)
    const excelData = this.bankDetails.map((item: any) => ({
      'Txn Date': item.txnDate,
      'Txn ID': item.txnId,
      'Amount': item.txnAmount,
      'Txn Description': item.txnDesc,
      'Bank Name': item.txnBranch?.bank_name,
      'IFSC Code': item.txnBranch?.ifsc,
      'Branch Name': item.txnBranch?.branch_name,
      'Branch Address': item.txnBranch?.address,
      'Branch City': item.txnBranch?.city,
      'Branch District': item.txnBranch?.district,
      'Branch State': item.txnBranch?.state,
      'Branch Pincode': item.txnBranch?.pincode
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Bank Transactions': worksheet },
      SheetNames: ['Bank Transactions']
    };

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    this.saveExcelFile(excelBuffer, `Bank_Transactions_${this.bankDetails[0].txnBranch?.district}_${this.bankDetails[0].txnBranch?.state}`);
  }
  onClickDocx(alDeatels: any, event: MouseEvent) {
    const dialogRef = this.dialog.open(UploadDocumentDialogComponent, {
      width: '520px',
      panelClass: 'custom-dialog-container',
      data: {
        data: alDeatels
      }
    })
    // this.isSuccessUpload =  alDeatels.traceDetails

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log(result.data);
      }
    });
  }

  openViewTrace(event:any) {
    const dialogRef = this.dialog.open(ViewTraceComponent, {
      width: '40vw',
      height: 'auto',
      panelClass: 'custom-dialog-container',
      data: {
        data: event
      }
    });
  }


}


